import { Injectable, Param } from "@nestjs/common";
import { Repository,Raw,getConnection } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { DownTimeReason } from "./dto/downtimereason.entity";
import { DownTimeReasonDto } from "./dto/downtimereason.dto";
import { DownTimeReasonAdapter } from "./dto/downtimereason.adapter";
import { DownTimeReasonResponsemodel } from "@gtpl/shared-models/masters";
import { AllDownTimeReasonResponseModel } from "@gtpl/shared-models/masters";
import { DownTimeReasonRequest } from "./dto/downtimereason.request";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { LogsDto } from "libs/shared-models/user-logs/src/lib/Logs/logs.dto";


@Injectable()

export class DownTimeReasonService{
    constructor(
      private logService:LogsService,

        @InjectRepository(DownTimeReason)
        private downtimereasonRepository: Repository<DownTimeReason>,
        private downtimereasonAdapter: DownTimeReasonAdapter,
    ){}

/**
     * get DownTime details
     * @param downtimeReason 
     */
    // @LogActions({isAsync: true})
    async getDownTimeReasonDetailsWithoutRelations(downtimeReason: string): Promise<DownTimeReason> {
        // tslint:disable-next-line: typedef
        const DowmTimeReasonResponse = await this.downtimereasonRepository.findOne({
          where: {downtimeReason: Raw(alias => `downtime_reason = '${downtimeReason}'`)},
        });
        if (DowmTimeReasonResponse) {
          return DowmTimeReasonResponse;
        } else {
          return null;
        }
      }

    


    async createDownTimeReason(downtimereasonDto: DownTimeReasonDto, isUpdate: boolean): Promise<DownTimeReasonResponsemodel> {
        // console.log(statesDto);
        try {
          // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          if (!isUpdate) {
            const downtimereasonEntity = await this.getDownTimeReasonDetailsWithoutRelations(downtimereasonDto.downtimeReason);
            if (downtimereasonEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new DownTimeReasonResponsemodel(false,11104, 'downtimereason already exists');
            }
          }
          else{
            const downtimereasonEntity = await this.getDownTimeReasonDetailsWithoutRelations(downtimereasonDto.downtimeReason);
            if (downtimereasonEntity) {
              if(downtimereasonEntity.downtimereasonId!=downtimereasonDto.downtimereasonId) {
                throw new DownTimeReasonResponsemodel(false,11104, 'reason already exists');      
            }
              //return new InformationMessageError(11104, "State already exists");
            }
          }
          const convertedDowntimereasonEntity: DownTimeReason = this.downtimereasonAdapter.convertDtoToEntity(downtimereasonDto,isUpdate);
          const savedDowntimeReasonEntity: DownTimeReason = await this.downtimereasonRepository.save(
            convertedDowntimereasonEntity
          );
          const savedDowntiemreasonDto: DownTimeReasonDto = this.downtimereasonAdapter.convertEntityToDto(convertedDowntimereasonEntity);
            // console.log(savedStateDto);
          if (savedDowntiemreasonDto) {
            // generating resposnse
            const response = new DownTimeReasonResponsemodel(true,1,isUpdate? 'DowntimeReason Updated Successfully': 'DownTimeReason Created Successfully')
            const name=isUpdate?'updated':'created'
            // const newLogDto = new LogsDto(1,name, 'DownTimeReason', savedDowntiemreasonDto.downtimereasonId, true, '',savedDowntiemreasonDto.createdUser)
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new DownTimeReasonResponsemodel(false,11106,'DowntimeReason saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          return error;
        }
      }  

      async getAllDownTimeReasons(): Promise<AllDownTimeReasonResponseModel> {
        // const page: number = 1;
        
        try {
          const downtimereasonDtos: DownTimeReasonDto[] = [];
          //retrieves all companies
          const DownTimeReasonEntities: DownTimeReason[] = await this.downtimereasonRepository.find({order :{'downtimeReason':'ASC'}});
          //console.log(statesEntities);
          if (DownTimeReasonEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            DownTimeReasonEntities.forEach(DownTimeReasonEntity => {
              const convertedDownTimeReasonDto: DownTimeReasonDto = this.downtimereasonAdapter.convertEntityToDto(
                DownTimeReasonEntity
              );
              downtimereasonDtos.push(convertedDownTimeReasonDto);
            });
            const response = new AllDownTimeReasonResponseModel(true,1,'DownTimeReason retrieved successfully',downtimereasonDtos);
            //generated response
            const newLogDto = new LogsDto(1,'view', 'DownTimeReason', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response
          } else {
            throw new DownTimeReasonResponsemodel(false,99998, 'Data not found');
          }
        
        } catch (err) {
          return err;
        }
      }



      async getAllActiveDownTimeReason(): Promise<AllDownTimeReasonResponseModel> {
        // const page: number = 1;
        try {
            const DowntimereasonDto: DownTimeReasonDto[] = [];
            //retrieves all companies
            const DowntimereasonEntities: DownTimeReason[] = await this.downtimereasonRepository.find({ order: { 'downtimeReason': 'ASC' },where:{isActive:true},
           });
         console.log(DowntimereasonEntities)
            if (DowntimereasonEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                DowntimereasonEntities.forEach(downtimereasonEntity => {
                    const converteddowntimereasonDto: DownTimeReasonDto = this.downtimereasonAdapter.convertEntityToDto(
                      downtimereasonEntity
                      
                    );
                    DowntimereasonDto.push(converteddowntimereasonDto);
                });
                const response = new AllDownTimeReasonResponseModel(true, 11108, "Downtimereasons retrieved successfully", DowntimereasonDto);
                return response;
            } else {
                throw new DownTimeReasonResponsemodel(false,99998, 'Data not found'); DowntimereasonDto
            }
        } catch (err) {
            return err;
        }
    }



      async activateOrDeactivateDownTimeReason(downtimereasonReq: DownTimeReasonRequest): Promise<DownTimeReasonResponsemodel> {
        try {
            const DownTimeReasonExists = await this.getDowTimeReasonById(downtimereasonReq.downtimereasonId);
            if (DownTimeReasonExists) {
                if (downtimereasonReq.versionFlag !== DownTimeReasonExists.versionFlag) {
                    throw new DownTimeReasonResponsemodel(false,10113, 'Someone updated the current DownTimeReason information.Refresh and try again');
                } else {
                    
                        const downtimereasonStatus =  await this.downtimereasonRepository.update(
                            { downtimereasonId: downtimereasonReq.downtimereasonId },
                            { isActive: downtimereasonReq.isActive,updatedUser: downtimereasonReq.updatedUser });
                       
                        if (DownTimeReasonExists.isActive) {
                            if (downtimereasonStatus.affected) {
                                const downtimereasonResponse: DownTimeReasonResponsemodel = new DownTimeReasonResponsemodel(true, 10115, 'DowntimeReason is de-activated successfully');
                                return downtimereasonResponse;
                            } else {
                                throw new DownTimeReasonResponsemodel(false,10111, 'DownTime is already deactivated');
                            }
                        } else {
                            if (downtimereasonStatus.affected) {
                                const DownTimeReasonResponse: DownTimeReasonResponsemodel = new DownTimeReasonResponsemodel(true, 10114, 'DowntimeReason is activated successfully');
                                return DownTimeReasonResponse;
                            } else {
                                throw new DownTimeReasonResponsemodel(false,10112, 'DownTimeReason is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new DownTimeReasonResponsemodel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getActiveDownTimeReasonById(downtimeresonReq: DownTimeReasonRequest): Promise<DownTimeReasonResponsemodel> {
      try {
        //retrieves all companies
        const DowntimeReasonEntities: DownTimeReason = await this.downtimereasonRepository.findOne({
            where:{downtimereasonId:downtimeresonReq.downtimereasonId}
            });
            
            const downtimereasonsData: DownTimeReasonDto = this.downtimereasonAdapter.convertEntityToDto(DowntimeReasonEntities);
            if (downtimereasonsData) {
                const response = new DownTimeReasonResponsemodel(true, 11101 , 'DowntimeReason retrived Successfully',downtimereasonsData);
                return response;
            }
            else{
                throw new DownTimeReasonResponsemodel(false,11106,'Something went wrong');
            }
            // generating resposnse
    } catch (err) {
        return err;
    }
  }


    async getDowTimeReasonById(downtimereasonId: number): Promise<DownTimeReason> {
      //  console.log(employeeId);
          const Response = await this.downtimereasonRepository.findOne({
          where: {downtimereasonId: downtimereasonId},
          });
          // console.log(employeeResponse);
          if (Response) {
          return Response;
          } else {
          return null;
          }
      }


    }
